import React from 'react';
import classNames from 'classnames';

class TabSectionTab extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    this.props.onClick(this.props.tabIndex);
  }

  render() {
    const className = classNames('TabSection-tab', {
      'TabSection-tab--active': this.props.isActive,
    });

    return (
      <li>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid */}
        <a className={className} onClick={this.handleClick}>
          {this.props.title}
        </a>
      </li>
    );
  }
}

export default TabSectionTab;
